import { combineReducers } from 'redux';
import {routerReducer} from 'react-router-redux';
import gas from './gasReducer';
import form from './formReducer';

export default combineReducers({
  gas,
  form,
  routing: routerReducer
});